import apiClient from '../../lib/axios';

export const fetchFundDisbursements = async ({
  page = 1,
  pageSize = 10,
  fundCommitment,
} = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (fundCommitment) params.append('fundCommitment', fundCommitment);
  const { data } = await apiClient.get(`/api/fund-disbursements?${params.toString()}`);
  return data;
};

export const fetchFundDisbursementById = async (id) => {
  const { data } = await apiClient.get(`/api/fund-disbursements/${id}`);
  return data;
};

export const createFundDisbursement = async (payload) => {
  const { data } = await apiClient.post('/api/fund-disbursements', payload);
  return data;
};

export const updateFundDisbursement = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/fund-disbursements/${id}`, payload);
  return data;
};

export const deleteFundDisbursement = async (id) => {
  const { data } = await apiClient.delete(`/api/fund-disbursements/${id}`);
  return data;
};

export default fetchFundDisbursements;
